import { Component, Inject } from '@angular/core'
import { BasePanelComponent, LayoutContainer } from '@helios/panel-base'
import {
  RootState,
  selectActualReconDate,
  selectFocusedMyAccount,
} from '@helios/state-management'
import { Store } from '@ngrx/store'
import { ComponentContainer } from 'golden-layout'
import { Subject } from 'rxjs'
import {
  debounceTime,
  distinctUntilChanged,
  take,
  takeUntil,
} from 'rxjs/operators'
import { RawTradeSummaryKey } from '../panel-key'
import { toISOFormat } from '@northfork/basics'
import { WorkspaceGridSavedViewService } from '@helios/user-preferences'
@Component({
  selector: 'hs-raw-trade-summary',
  templateUrl: './raw-trade-summary-panel.component.html',
  styleUrls: ['./raw-trade-summary-panel.component.scss'],
})
export class RawTradeSummaryPanelComponent extends BasePanelComponent {
  panelKey = RawTradeSummaryKey
  private readonly _destroyed$ = new Subject<void>()
  source = 'helios'
  accountId?: number
  reconDate?: string

  constructor(
    @Inject(LayoutContainer) container: ComponentContainer,
    private readonly store: Store<RootState>,
    readonly savedViewService: WorkspaceGridSavedViewService,
  ) {
    super(container)
  }

  ngOnDestroy(): void {
    this._destroyed$.next()
    this._destroyed$.complete()
  }

  ngOnInit() {
    this.store
      .select(selectActualReconDate)
      .pipe(take(1), takeUntil(this._destroyed$))
      .subscribe((reconDate?: Date) => {
        if (reconDate === undefined) return
        this.reconDate = toISOFormat(reconDate) as string
      })
    this.store
      .select(selectFocusedMyAccount)
      .pipe(
        debounceTime(500),
        takeUntil(this._destroyed$),
        distinctUntilChanged(),
      )
      .subscribe(account => {
        this.accountId = account?.accountId
      })
  }
}
